import styles from "./styles.module.scss";

const HeroSection = () => {
  return (
    <section className={styles.root}>
      <h1 className={styles.title}>
        <em>Велнес Фитнес</em>
        проекты
      </h1>
      <p className={styles.creating}>
        Комплексное проектирование объектов для отдыха, здоровья, восстановления
        и активного долголетия
      </p>
    </section>
  );
};

export default HeroSection;
